import { inject } from '@angular/core';
import { HttpErrorResponse, HttpInterceptorFn, HttpResponse } from '@angular/common/http';
import { Router } from '@angular/router';
import { catchError, of, throwError } from 'rxjs';
import { ErrorHandlerService } from '../core/services/app-error-handler.service';

export const errorInterceptor: HttpInterceptorFn = (req, next) => {
  const errorHandler = inject(ErrorHandlerService);
  const router = inject(Router);

  return next(req).pipe(
    catchError((error: HttpErrorResponse) => {
      // Unauthorized application user
      const isUnauthorizedUser =
        error.status === 404 &&
        /getuserdetails/i.test(req.url) &&
        error.error?.success === false &&
        /no user found with email/i.test(error.error?.message ?? '');

      if (isUnauthorizedUser) {
        void router.navigate(['/unauthorized']);
        return throwError(() => error);
      }

      const isTaxAccountingNoDataError = error.status === 404 && /getasc740details/i.test(req.url);

      const isFilterNoDataError = error.status === 404 && /getissuedetailsbyfilter/i.test(req.url);

      const isArFilingNoDataError =
        (error.status === 400 || error.status === 404) && /getarfillingid/i.test(req.url);

      if (isTaxAccountingNoDataError || isFilterNoDataError || isArFilingNoDataError) {
        return of(
          new HttpResponse({
            status: 200,
            body: {
              success: true,
              message: isArFilingNoDataError ? 'No records found' : '',
              result: isArFilingNoDataError ? [] : null,
            },
          }),
        );
      }

      if (error.status === 409) {
        return throwError(() => error);
      }

      const errorMessage = errorHandler.handle(error);

      console.error('API Error:', {
        url: req.url,
        method: req.method,
        status: error.status,
        message: errorMessage,
        error,
      });

      switch (error.status) {
        case 403:
        case 404:
        case 500:
        case 502:
        case 503:
          void router.navigate(['/error'], {
            state: {
              statusCode: error.status,
              message: errorMessage,
            },
          });
          break;
      }

      return throwError(() => error);
    }),
  );
};
